import React, { Component } from 'react';
import { Grid,Row, Column, Keyboard, Form, FormInput, cls } from 'packages/components';
import './styles.scss';
import SearchContent from './SearchContent';
import LoadingIptvOttFlow from '../../AAF/LoaderExp/LoadingIptvOttFlow';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import SearchConstants from './SearchConstants';
import Utils from '../../utils/Utils';
import UtilsSearch from './UtilsSearch';
import {getLastTouch} from "../../requests/utils/utils-last-touch";

class Search extends Component {
    constructor() {
        super();
        this.text_label_popular = Translator.get('popularSearches_default_title_label', 'Búsquedas populares:');
        this.text_label_search_success = Translator.get('resultSearches_default_title_label', 'Resultados:');

        this.text_label_search_not_success_one_part = Translator.get('withoutResults_alert_title_label', 'No encontramos coincidencias para:');
        this.text_label_search_not_success_second_part = Translator.get('withoutResults_alert_description_label', 'Utilizá otras palabras clave, buscá por nombre de actor o director o probé con un género. Podés también elegir entre las opciones que te sugerimos a continuación:');

        this.text_label_kids_search_not_success_one_part = Translator.get('kids_withoutResults_alert_title_label', 'Es posible que este contenido no esté disponible para este perfil.');
        this.text_label_kids_search_not_success_second_part = Translator.get('kids_withoutResults_alert_description_label', 'Puedes elegir entre las opciones que te sugerimos a continuación.');

        this.text_place_holder = Translator.get('search_default_placeHolder_textfield', 'Títulos, géneros, artistas');
        this.search_Icon = Asset.get('search_menu_option_button_popularSearches', false)
        this.state = {
            search: null,
            text: null
        }
        this.searchTimeOut = null;
        this.text_label_api_error = Translator.get('popularSearches_withoutResults_alert_title_label','No se pueden mostrar los contenidos, intenta más tarde.')
    }

    componentWillUnmount = () => {
        //* Se comenta para que no se borre el historial de busqueda al salir de la pantalla en caso de que se vuelva a ingresar
        // UtilsSearch.clearDataStorSearch();
    }

    componentDidMount = () => {
      getLastTouch("seen").then(lastTouchSeen => {
        this.setState({ lastTouchSeen });
      })
        const auxWordsSearch = UtilsSearch.getWordsStorage();
        const wordChangeTextSearch = auxWordsSearch ? SearchConstants.SEARCH_FOUND : SearchConstants.SEARCH_POPULAR;

        window.SpatialNavigation.focus('.aaf_form-group-focus-alphanumeric');
        if(!LoadingIptvOttFlow.isLoadLive()){
            this.props && (typeof this.props.loadLinealChannels == 'function') && this.props.loadLinealChannels();
            this.props && (typeof this.props.chargeLiveComponents == 'function') && this.props.chargeLiveComponents();
        }
        Utils.setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
        this.state = {
            text: this.changeTextSearch(wordChangeTextSearch),
            search: auxWordsSearch
        }
    }

    shouldComponentUpdate = (nextProps, nextState) =>{
        if(nextState.search !== this.state.search || nextState.text !== this.state.text){
            return true;
        }else{
            return false;
        }
    }

    onChange = (value) => {
        let auxValue = value;
        if(value.length >= 43) auxValue = value.substring(0, 43);

        if (this.searchTimeOut) clearTimeout(this.searchTimeOut);

        this.searchTimeOut = setTimeout(() => {
            this.setState({ search: auxValue });
            UtilsSearch.updateDataStoreSearcher({wordsSearch: auxValue})
        }, 100);
    }

    changeRoute = (path) =>{
        const { history } = this.props;
        history.push(path);
    }

    changeTextSearch = (text) =>{
        let textBuild = '';
        switch(text){
            case SearchConstants.SEARCH_POPULAR:
            case SearchConstants.SEARCH_EMPTY:
                textBuild = this.getHTMLPopularLabel();
            break;
            case SearchConstants.SEARCH_FOUND:
                textBuild = this.getHTMLSearchFoundLabel();
            break;
            case SearchConstants.SEARCH_NOT_FOUND:
                textBuild = this.getHTMLSearchNotFoundLabel();
            break;
            case SearchConstants.SEARCH_CLEAR:
                textBuild = this.getHTMLEmptyLabel();
            break;
            case SearchConstants.SEARCH_NOT_FOUND_KIDS:
                textBuild = this.getHTMLSearchNotFoundLabel(true);
            break;
            default:
        }
        this.setState({
            text: textBuild
        });
    }

    getHTMLEmptyLabel = () =>{
        return null;
    }



    getHTMLPopularLabel = () =>{
        return (
            <span>{this.text_label_popular}</span>
        );
    }

    getHTMLSearchFoundLabel = () =>{
        return (
            <span>{this.text_label_search_success}</span>
        );
    }
    getHTMLSearchNotFoundLabel = (isKids = false) =>{
        const {search =  ''} = this.state;
        const textFirst = isKids
        ? this.text_label_kids_search_not_success_one_part
        : this.text_label_search_not_success_one_part;

        const textSecond = isKids
        ? this.text_label_kids_search_not_success_second_part
        : this.text_label_search_not_success_second_part;

        const classFirst = isKids
        ? 'aaf_main_search_container_text_label_not_found_one_kids'
        : 'aaf_main_search_container_text_label_not_found_one';
        const classSecond = isKids
        ? 'aaf_main_search_container_text_label_not_found_two_kids'
        : 'aaf_main_search_container_text_label_not_found_two';

        return (
            <Row className="aaf_main_search_container_text_not_found">
                <Column className ={classFirst} lg={12}>{textFirst}</Column>
                {!isKids && <Column className ={'aaf_main_search_container_text_label_not_found_text'} lg={12}>{search}</Column>}
                <Column className ={classSecond} lg={12}>{textSecond}</Column>
                {isKids && <Column className ={'aaf_main_search_container_text_label_not_found_popular'} lg={12}>
                    {this.getHTMLPopularLabel()}
                </Column> }
            </Row>
        );
    }


    onFocus () {
        Utils.onFocusElement([{ id: 'searchInput'}]);
    }

    render() {
        const { search = null, text} = this.state;
        return (
            <Grid className={`aaf_main_search_container`}>
                <Form className={`aaf_main_search_container_form`}>
                    <Column lg={6} className={`aaf_main_search_container_keyboard`}>
                        <Keyboard  onFocus = {this.onFocus} withoutEmails fromSearch/>
                    </Column>
                    <Column lg={6} className={`aaf_main_search_container_results`}>
                        <Column lg={12} className={'aaf_main_search_container_text_input'}>
                            <FormInput
                                id="searchInput"
                                focusWhenMount={() => { }}
                                name="search"
                                type="text"
                                placeholder={this.text_place_holder}
                                onChange={this.onChange}
                                fromSearch={true}
                                value={search}
                            >
                                {this.search_Icon && <span className="helper"/>}
                                {this.search_Icon && <img src={this.search_Icon} alt="Search icon"/> }
                            </FormInput>
                        </Column>
                        <Column lg={12} className={'aaf_main_search_container_text_label'}>
                            {text}
                        </Column>
                        <Column lg={12}>
                            <SearchContent  onFocus = {this.onFocus} search={search} changeRoute={this.changeRoute} changeTextSearch ={this.changeTextSearch} textAPIError = {this.text_label_api_error}/>
                        </Column>
                    </Column>
                </Form>
            </Grid>
        )
    }

}


export default Search;



// WEBPACK FOOTER //
// ./src/containers/Search/index.jsx